/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Payment_Remaining_ColInputs */

const vi_customer_debt_payment_remaining_col = /** @type {(inputs: Customer_Debt_Payment_Remaining_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Còn nợ`)
};

/**

* @param {Customer_Debt_Payment_Remaining_ColInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_payment_remaining_col = /** @type {((inputs?: Customer_Debt_Payment_Remaining_ColInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Payment_Remaining_ColInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_payment_remaining_col(inputs)
});